import React from 'react'

import { shortDate } from 'helpers/formatters'

import Checkbox from 'components/Checkbox'

import FormSection from 'pages/shared/FormSection'

type onChangeCallbackArg = {
  published?: boolean
}

type props = {
  publishedAt: string
  published: boolean
  onChangeCallback: (arg: onChangeCallbackArg) => void
}

const UpdatesPageFields = ({ published, publishedAt, onChangeCallback }: props) => {
  return (
    <FormSection title="Updates Page">
      <Checkbox
        label={`Published ${publishedAt ? ` (${shortDate(publishedAt)})` : ''}`}
        checked={published}
        onChange={() => onChangeCallback({ published: !published })}
      />
    </FormSection>
  )
}

export default UpdatesPageFields
